export function addSortToQuery(query: string | undefined, sort: string): string {
  const sortFilter = sort ? `sort:${sort}` : ''

  if (!query) return sortFilter

  const nonSortTerms = query.split(' ').filter(term => !term.startsWith('sort:'))
  if (nonSortTerms.length === 0) return sortFilter

  const base = nonSortTerms.join(' ')
  return sortFilter ? `${base} ${sortFilter}` : base
}

export function getSortFromQuery(query: string | undefined): string {
  if (!query) return ''

  const sortTerms = query.split(' ').filter(term => term.startsWith('sort:'))
  if (sortTerms.length === 0) return ''

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return sortTerms[0]!.substring('sort:'.length)
}
